import apiClient from "./client";

export interface FeatureFlag {
  name: string;
  enabled: boolean;
  enabledByDefault: boolean;
}

export const ENABLED_FLAGS_TIMEOUT_MS = 5000;

export const featureFlagsApi = {
  getAll: async (): Promise<FeatureFlag[]> => {
    try {
      const response = await apiClient.get<FeatureFlag[]>("/admin/feature-flags");
      return response.data;
    } catch (error) {
      throw new Error("Failed to fetch feature flags. Please try again.");
    }
  },

  getEnabled: async (): Promise<string[]> => {
    // A cold backend or a slow mobile network can blow well past 1s on first
    // hit, so: generous timeout, and one retry before giving up (callers fall
    // back to the last-known flags).
    for (let attempt = 0; attempt < 2; attempt++) {
      try {
        const response = await apiClient.get<string[]>("/app/features", { timeout: ENABLED_FLAGS_TIMEOUT_MS });
        if (!Array.isArray(response.data)) throw new Error('Invalid response');
        return response.data;
      } catch {
        /* retry once, then fall through */
      }
    }
    throw new Error("Failed to fetch enabled features.");
  },

  toggle: async (name: string, enabled: boolean): Promise<FeatureFlag> => {
    try {
      const response = await apiClient.put<FeatureFlag>(
        `/admin/feature-flags/${name}`,
        { enabled }
      );
      return response.data;
    } catch (error) {
      throw new Error(`Failed to update feature flag "${name}". Please try again.`);
    }
  },
};
